import { Box, Breadcrumbs, Button, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { setEditQuestion, stateRefresh, stateValues } from '../../slices/inPlaySlice';
import { useDispatch, useSelector } from "react-redux";
import { AiFillCloseCircle } from 'react-icons/ai';
import { CHANGESTATUS, GET_MATCH_NAME, INPLAY, IN_PLAY_RATE_CHANGE, SUSPENDINPLAY } from "../../constant/endpoint";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MdNavigateNext } from "react-icons/md";
import Swal from "sweetalert2";

export const SuspendInPlayContest = ({}) => {

    const predictionState = useSelector((state) => state.inPlaySlice);
    const { match_id, series_id, sport , pred_id} = useParams()
    const dispatch = useDispatch();
    const setQuestion = (e) => { 
        let targetValue = e.target.value 
        console.log("targetValue", targetValue);
        if (e.target.name === "line_red" || e.target.name === "line_green") {
            if (e.target.name === "line_red" && targetValue > 96) {
                if (targetValue > 99)
                    e.target.value = 99
                dispatch(stateValues({ name: "line_green", value: 99 }))
            }
            else if (e.target.name === "line_green" && targetValue > 99) {
                e.target.value = 99
            }
            else if (e.target.name === "line_red" && targetValue <= 96) {
                dispatch(stateValues({ name: "line_green", value: Number(e.target.value) + 3 }))

            }
            dispatch(stateValues({ name: e.target.name, value: e.target.value }))
        }

        dispatch(stateValues({ name: e.target.name, value: e.target.value }))

    }
    const [currentData, setCurrentData] = useState("");
    const [matchData, setMatchData] = useState("");


    const handleLineRedEnter = async (event, data) => {

       console.log(data.favourite_team_id,"data.favourite_team_id");
        if (event.key == "Enter") {
         if (!data.favourite_team_id || data.favourite_team_id == "") {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Please Select Favourite Team",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
         }
            let line_red_sub = data.line_red_sub;
            let line_green_add = data.line_green_add ;
            let line_green =data.line_green !== "" ? data.line_green :  data.line_red + 3
            let line_red = data.line_red
            console.log("line_green", line_green);

            let total_line_green = Number(line_green) + Number(line_green_add)
            let total_line_red = Number(line_red) - Number(line_red_sub)
        //  let total_line_red =( Number(line_red) - Number(line_red_sub)) >= 0 ?  Number(line_red) - Number(line_red_sub) : 0
            
            // if (total_line_green > 99) {
            //     Swal.fire({
            //         position: "top-end",
            //         icon: "error",
            //         title: "Green Line should not be more than 99",
            //         showConfirmButton: false,
            //         timer: 1500,
            //     });
            //     return;
            //  }

         if (total_line_green >= 0 && total_line_green <= 100) {
          
             line_green = total_line_green
         }
         if (total_line_red >= 0 && total_line_red <= 100) {
             
             line_red = total_line_red
         }
         if (total_line_green >= 100) {
             line_green = 99
         }
         if (total_line_green <= 0) {
             line_green = 0
         }
         if (total_line_red >= 100) {
             line_red = 99
         }
         if (total_line_red <= 0) {
             line_red = 0
         }
            let req = {
                line_red: line_red,
                line_green: line_green,
                favourite_team_id: data.favourite_team_id,
                favourite_team: matchData.localteam_id == data.favourite_team_id ? matchData.localteam : matchData.visitorteam,
                line_green_add: line_green_add,
                line_red_sub: line_red_sub,
                line_red_previous: data.line_red,
                line_green_previous: data.line_green,
                predictionId:pred_id
            }

            await axios.post(IN_PLAY_RATE_CHANGE.replace(":match_id", match_id)
                , req)
            const inPlayData = {
                ...data,
                stop_join: 0,
            };
            dispatch(setEditQuestion(inPlayData));
        getOpinionTrading()

        }
    }

    const updateSuspendDetails = async (data, suspend) => {
        const response = await axios.post(IN_PLAY_RATE_CHANGE.replace(":match_id", match_id) + `?stop_join=1`, {predictionId:pred_id})
        if (response?.data?.status == "success") {

            const inPlayData = {
                ...data,
                stop_join: 1,
            };
            dispatch(setEditQuestion(inPlayData));
        }
        // getOpinionTrading()
    }
    const getOpinionTrading = async () => {
        const response = await axios.get(INPLAY.replace(':match_id', match_id).replace(':series_id', series_id))
        // setLoading(true)
        if (response?.data?.status)  {
            setCurrentData(getPredId(response.data.data))
            dispatch(setEditQuestion(getPredId(response.data.data)));
            // setLoading(false)
        }
    }
    const getMatchDetails = async () => {
        const response = await axios.get(GET_MATCH_NAME.replace(':match_id', match_id))
        // setLoading(true)
        if (response?.data?.status) {
            setMatchData(response?.data?.data)
            console.log("getMatchDetails",response?.data?.data);
            // setLoading(false)
        }
    }

    const getPredId = (arr) => {
        let data = {}
        data = arr.find((pre) => pre._id === pred_id)
        console.log("data", data);
        return {
            ...data,
            stop_join: 0,
            line_red: Number(data.line_red) >= 99  ? Number(data.line_red) :   Number(data.line_red_previous),
            line_green: Number(data.line_green_previous)
        }
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>,<Link underline="hover"
            color="inherit"  to={`/matchlist/in_play/${match_id}/${series_id}/1`} >
            <h5>{'QUIZ PLAY'}</h5>
        </Link>,
        <h5>{ pred_id}</h5>
    ];
    const questionStatus = async () => {
        let data;
        let status = predictionState?.questionStates?.status
        let predInfo = predictionState?.questionStates
        let _id = predInfo._id
        if (status) {
            data = { status: 0, match_id, series_id, _id }
        } else {
            data = { status: 1, match_id, series_id, _id }
        }
        if (data.status === 1 && predInfo.is_over_under && predInfo.over_runs <= 0) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Please Enter Over Runs",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
        }
        await axios.post(CHANGESTATUS, data)
        getOpinionTrading()
    }

    useEffect(() => {   
        getOpinionTrading()
        getMatchDetails()
     }, [])
    
    
    return (
        // <Dialog open={isOpenSuspend} >
             <center>
                <Box style={{ padding: "20px 80px", margin:"80px 0 0 0" }}>
                <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>Suspend Question</h2>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={4}>
                                <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                        </Grid>
                            <Grid item xs={4}>
                                <h4 style={{wordBreak: "break-all"}}>{`Question English : ${predictionState?.questionStates?.question_english}`}</h4>
                        </Grid>

                        <Grid xs={12} item mb={2}>
                        <Button variant={'contained'} size={'large'} color={predictionState?.questionStates?.status ? 'success' : 'error'} onClick={() => questionStatus()} >{predictionState?.questionStates?.status ? 'Active' : 'InActive'}</Button>
                    </Grid>
                        
                        </Grid>
                    </Grid>
                    <hr />
               
                <Grid container style={{ justifyContent: "start" }} mb={4}>
                <Grid xs={2} item mr={1} >
                        <label>Favourite Team</label>
                        <Select
                            id="outlined-basic"
                            size={'small'}
                            fullWidth
                            variant="outlined"
                            name={'favourite_team_id'}
                            onChange={setQuestion}
                            value={predictionState?.questionStates?.favourite_team_id || ""}
                        >
                            <MenuItem value={""}>Select</MenuItem>
                            <MenuItem value={matchData?.localteam_id}>{matchData?.localteam}</MenuItem>
                            <MenuItem value={matchData?.visitorteam_id}>{matchData?.visitorteam}</MenuItem>
                        </Select>

                    </Grid>
                    <Grid xs={2} item  >
                                            <label>Line Red</label>
                        <TextField
                            id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'line_red'} onChange={setQuestion} value={predictionState.questionStates.line_red} onKeyDown={(event) => { handleLineRedEnter(event, predictionState.questionStates) }} />
                    </Grid>
                    <Grid xs={3} item mt={2}>
                    <Button variant={'contained'} size={"large"} color={predictionState.questionStates.stop_join ? 'error' : 'info'}  onClick={()=>{updateSuspendDetails(predictionState.questionStates )}}>Suspend</Button>
                    </Grid>
                    <Grid xs={2} item>
                                            <label>Line Green</label>
                                            <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'line_green'} onChange={setQuestion} onKeyDown={(event)=>{handleLineRedEnter(event, predictionState.questionStates)}}  value={(predictionState.questionStates.line_green)}  />
                    </Grid>
                  
                  
                    
                </Grid>
                <hr></hr>
                <h3>Add on Value</h3>
                <Grid container mt={4}>
          
                    <Grid xs={3} mr={2} item  >
                        <label>Line Red </label>
                        <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'line_red_sub'}  onChange={setQuestion} value={predictionState.questionStates.line_red_sub} onKeyDown={(event) => { handleLineRedEnter(event, predictionState.questionStates) }} />
                    </Grid>
                   
                    <Grid xs={3} item>
                        <label>Line Green </label>
                        <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'line_green_add'}  onChange={setQuestion} value={predictionState.questionStates.line_green_add}  onKeyDown={(event) => { handleLineRedEnter(event, predictionState.questionStates) }} />
                    </Grid>

                </Grid>
               
                   
                   
                </Box>
                </center>
          
        // </Dialog>
    )
}